import * as React from 'react';
// @ts-expect-error
import type {Watch, Control} from 'react-hook-form';

import {Button} from 'shells/button/button';
import {CollapsibleCard} from 'shells/card/collapsible-card';
import {Body} from 'shells/typography/body';

import type {Field} from '../../../../types';

import {ImageDesignForm} from './image-design-form';
import {LabelDesignForm} from './label-design-form';
import {SubmitButtonDesignForm} from './submit-button-design-form';
import {TextInputDesignForm} from './text-input-design-form';
import {TextfieldDesignForm} from './textfield-design-form';

import styles from '../design-form.module.css';

type Props = {
    field: Field;
    name: string;
    control: Control;
    onDeselectField: () => void;
    title: string;
    watch: Watch;
};

const FIELD_DETAILS_FORM_MAP = {
    INPUT: TextInputDesignForm,
    RADIO: TextfieldDesignForm,
    CHECKBOXES: TextfieldDesignForm,
    FILE: TextfieldDesignForm,
    URL: TextInputDesignForm,
    TEXT: LabelDesignForm,
    SUBHEADER: LabelDesignForm,
    HEADER: LabelDesignForm,
    SUBMIT_BUTTON: SubmitButtonDesignForm,
    IMAGE: ImageDesignForm,
    DATE: TextInputDesignForm,
} as const;

export function FieldDesignForm(props: Props) {
    const Component = FIELD_DETAILS_FORM_MAP[props.field.type];

    const [isOpen, setIsOpen] = React.useState<boolean>(true);

    return (
        <CollapsibleCard
            header={
                <Button
                    variant='text-secondary'
                    size='big'
                    onClick={props.onDeselectField}
                    noPadding={true}
                >
                    <Body color='dark' size='large' isBold={true}>
                        Form design
                    </Body>
                </Button>
            }
            subheader={<Body color='light'>{props.title}</Body>}
            padding={16}
            isOpen={isOpen}
            setIsOpen={setIsOpen}
            hasBorder={true}
            hasShadow={true}
            fitHeight={false}
            fitContent={false}
        >
            <div className='pt-16'>
                <div className={styles['design-fields-container']}>
                    <Component
                        control={props.control}
                        name={props.name}
                        watch={props.watch}
                        field={props.field}
                    />
                </div>
            </div>
        </CollapsibleCard>
    );
}
